/**
 * Asynchronously converts a `File` to a base64 string.
 * @param file The file to convert.
 * @param stripType Strips the type from the start of the string, eg ` data:image/png;base64,`.
 */
export const fileToBase64 = (file: File, stripType?: boolean): Promise<any> => new Promise((resolve, reject) => {
  if (!file) {
    reject(new Error('No file was provided'));
  }
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    const { result } = reader;
    if (stripType) {
      resolve((result as string).split(',')[1]);
    } else {
      resolve((result as string));
    }
  };
  reader.onerror = (error) => reject(error);
});
